import { combineReducers } from "redux";
import appState from "./appState/reducer";
import user from "./user/reducer";
import items from "./items/reducer"

export default combineReducers({
  appState,
  user,
  items
});
